export enum BuilderEditModeEnum {
  allTypes,
  matrix,
  instructionalText,
}
